
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1_4)"}},[_c('path',{attrs:{"d":"M487.64 268.69L339.447 416.748c-7.147 7.141-18.734 7.141-25.881 0l-17.284-17.268c-7.135-7.129-7.148-18.682-.03-25.827l117.445-117.892L296.252 137.87c-7.118-7.145-7.105-18.698.03-25.827l17.284-17.268c7.148-7.14 18.735-7.14 25.881 0L487.64 242.833c7.147 7.14 7.147 18.717 0 25.857z"}}),_c('path',{attrs:{"d":"M98.002 226.55V-18H37v547h61.002V287.497h342.376V226.55H98.002z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1_4"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h512v512H0z"}})])])])
          )
        }
      }
    